import * as React from "react";
import { Card, CircularProgress, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import no_foto from "assets/images/not_found_image.jpg";
import { PrintContainer } from "components/Printing";
import DataTable from "examples/Tables/DataTable";
import { useGetAsignaturasPorProfesorQuery } from "services";

const DetailItem = ({ label, value }) => (
  <MDBox mb={1} width="100%" pr={1}>
    <MDTypography
      variant="caption"
      fontWeight="bold"
      color="text"
      display="block"
      gutterBottom
    >
      {label}
    </MDTypography>
    <MDTypography
      variant="body2"
      fontWeight="regular"
      color="dark"
      sx={{
        display: "block",
        width: "100%",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal",
        lineHeight: 1.4,
      }}
    >
      {value || "-"}
    </MDTypography>
  </MDBox>
);

const RegistroShow = ({ rowData }) => {
  const printRef = React.useRef(null);

  const profesorId = rowData?.resourcetypeFull?.find(
    (el) => el.resourcetype === "Profesor"
  )?.id;

  const isProfesor = Boolean(profesorId);

  const { data: asigPorProf, isLoading: isLoadingAP } =
    useGetAsignaturasPorProfesorQuery(
      {
        filter_params: {
          profesor: profesorId,
          query:
            "{id,url,distribucion_grupo{grupo{identificador}},asignatura{nombre,carrera,ciclo_interno}}",
        },
        shape: {
          id: "id",
          url: "url",
          grupo_ident: "distribucion_grupo.grupo.identificador",
          asignatura_name: "asignatura.nombre",
          carrera: "asignatura.carrera",
          ciclo_interno: "asignatura.ciclo_interno",
        },
      },
      {
        refetchOnReconnect: true,
        skip: !isProfesor,
      }
    );

  const tableAsignaturaPorProfesor = {
    columns: [
      { Header: "Carrera", accessor: "carrera" },
      { Header: "Ciclo Interno", accessor: "ciclo_interno" },
      { Header: "Grupo", accessor: "grupo_ident" },
      { Header: "Asignatura", accessor: "asignatura_name" },
    ],
    rows: asigPorProf ?? [],
  };

  const nombreCompleto = `${rowData?.apellido_paterno ?? ""} ${
    rowData?.apellido_materno ?? ""
  } ${rowData?.nombre ?? ""}`.trim();

  const telefonoMovil =
    rowData?.telefonos?.find((e) => e.tipo === "Móvil")?.telefono || "-";

  const roles = Array.isArray(rowData?.roles) ? rowData.roles.join(", ") : "-";
  const contrato = Array.isArray(rowData?.resourcetype)
    ? rowData.resourcetype.join(", ")
    : "-";

  return (
    <PrintContainer ref={printRef} title={`Plantilla - ${nombreCompleto}`}>
      <MDBox pb={1} position="relative" mt={{ xs: 7, md: 18 }}>
        <MDBox
          component="img"
          src={rowData?.foto !== null ? rowData?.foto : no_foto}
          alt={rowData?.nombre}
          borderRadius="50%"
          shadow="md"
          width="100px"
          height="100px"
          position="absolute"
          left="50%"
          top="-60px"
          sx={{ transform: "translateX(-50%)", zIndex: 1, objectFit: "cover" }}
        />

        <Card sx={{ overflow: "visible" }}>
          <MDBox p={3} pt={6}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <DetailItem label="Nombre completo" value={nombreCompleto} />
              </Grid>

              <Grid item xs={12}>
                <MDBox
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#344767",
                    opacity: 0.2,
                    my: 1,
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <DetailItem label="Correo institucional" value={rowData?.email} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DetailItem label="Teléfono móvil" value={telefonoMovil} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <DetailItem label="Rol" value={roles} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DetailItem label="Contrato" value={contrato} />
              </Grid>
            </Grid>

            {isProfesor && (
              <MDBox mt={2}>
                <MDBox
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#344767",
                    opacity: 0.2,
                    my: 1,
                  }}
                />
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Asignaturas que imparte
                </MDTypography>

                <MDBox display="flex" justifyContent="center" alignItems="center">
                  {isLoadingAP ? (
                    <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
                  ) : (
                    <DataTable
                      showTotalEntries={false}
                      entriesPerPage={false}
                      table={tableAsignaturaPorProfesor}
                    />
                  )}
                </MDBox>
              </MDBox>
            )}

            <MDBox
              className="no-print"
              display="flex"
              justifyContent="center"
              mt={3}
            >
              <MDButton
                variant="gradient"
                color="accent"
                onClick={() => printRef.current?.print()}
              >
                Imprimir
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </PrintContainer>
  );
};

export default RegistroShow;
